// config.js
const getBaseUrl = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");

  return "https://testtwo.ogpumper.net"; // Fallback base URL
};

export const baseUrl = getBaseUrl();

export const API_VERSION = "v1";
